import { render, staticRenderFns } from "./UsageFeesGroupHomeInsuredServiceCostsTable.vue?vue&type=template&id=1171ca68&scoped=true&lang=pug"
import script from "./UsageFeesGroupHomeInsuredServiceCostsTable.vue?vue&type=script&lang=ts"
export * from "./UsageFeesGroupHomeInsuredServiceCostsTable.vue?vue&type=script&lang=ts"
import style0 from "./UsageFeesGroupHomeInsuredServiceCostsTable.vue?vue&type=style&index=0&id=1171ca68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1171ca68",
  null
  
)

export default component.exports